// @flow
import React from 'react';

/*
Sample SVG output

<svg viewBox="0 0 100 1" preserveAspectRatio="none" style="display: block; width: 100%;">
  <path d="M 0,0.5 L 100,0.5" stroke="#555" stroke-width="1" fill-opacity="0" style="stroke-dasharray: 100, 100; stroke-dashoffset: 49;"></path>
</svg>
*/

type Props = {
  containerStyle: Object,
  progress: number
}

const ProgressBar = ({ containerStyle, progress }: Props) => (
  <div style={containerStyle}>
    <svg viewBox="0 0 100 1" preserveAspectRatio="none" style={{ display: 'block' }}>
      <path d="M 0,0.5 L 100,0.5" stroke="#555" strokeWidth="1" fillOpacity="0" style={{ strokeDasharray: '100, 100', strokeDashoffset: 100 - (progress * 100) }} />
    </svg>
  </div>
);

export default ProgressBar;
